import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FlexGrid, CellRangeEventArgs } from '@grapecity/wijmo.grid';

import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1409Model } from './kymw1409.model';
import { KYMW1409InputModel } from './vo/kymw1409-input.model';
import { NvalInputModel } from '../../../commons/kymw0a/kymw0a00/vo/nval-input.model';
import { DeleteUseMarkModel } from '../kymw1400/vo/delete-use-mark.model';
import { RegistUseMarkModel } from '../kymw1400/vo/regist-use-mark.model';
import { MarkListModel } from '../kymw1400/vo/mark-list.model';

import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';

import { DeleteUseMarkService } from './api-services/delete-use-mark.service';
import { GetMarkListService } from './api-services/get-mark-list.service';
import { RegistUseMarkService } from './api-services/regist-use-mark.service';


/**
 * マーク指示画面を管理するクラス
 *
 * @export KYMW1409Component
 * @class KYMW1409Component
 */
@Component({
  selector: 'app-kymw1409',
  templateUrl: 'kymw1409.component.html',
  styleUrls: ['kymw1409.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1409Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('dtg_MarkListDetail', { static: true }) dtg_MarkListDetail: FlexGrid;
  @ViewChild('dtg_GoodsInfoDetail', { static: true }) dtg_GoodsInfoDetail: FlexGrid;
  @ViewChild('cmb_MarkGroup', { static: true }) cmb_MarkGroup: ElementRef;
  @ViewChild('cmb_PCode', { static: true }) cmb_PCode: ElementRef;

  /**
   * 受渡情報ＶＯ
   */
  public inputVO: KYMW1409InputModel = null;

  setKYMW1409Parameter: Function = null;
  closeFunction: Function = null;
  kymw1409Model: KYMW1409Model = new KYMW1409Model();

  public editColumns: Array<any> = [''];
  public readonly COLUMN_WIDTH_DEFAULT: number = Number(394);
  public readonly COLUMN_WIDTH_MINIMUN: number = Number(130);
  public colWidth: any = this.COLUMN_WIDTH_MINIMUN;


  /**
   * Creates an instance of KYMW1409Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {ElementRef} elementRef
   * @param {KYMW00Model} kymw00Model
   * @param {DeleteUseMarkService} deleteUseMarkService
   * @param {GetMarkListService} getMarkListService
   * @param {RegistUseMarkService} registUseMarkService
   * @memberof KYMW1409Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private elementRef: ElementRef,
    private kymw00Model: KYMW00Model,
    private deleteUseMarkService: DeleteUseMarkService,
    private getMarkListService: GetMarkListService,
    private registUseMarkService: RegistUseMarkService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1409Component
   */
  public ngOnInit(): void {
    this.init_load();

    this.dtg_MarkListDetail.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      var ht = this.dtg_MarkListDetail.hitTest(e);
      if ((0 <= ht.row) && (2 <= ht.col)) {
        if (!ht.target.className.includes('wj-header') && !ht.target.className.includes("wj-glyph-down") && !ht.target.className.includes("wj-glyph-up")) {
          const pCode = this.editColumns[ht.col - 2];
          document.getElementById(`cb_${pCode}_${ht.row}`).click();
        }
      }
    });

    this.cmb_MarkGroup.nativeElement.focus();
  }

  /**
   * 画面初期処理
   *
   * @private
   * @memberof KYMW1409Component
   */
  private init_load(): void {
    this.componentName = 'KYMW1409';
    this.kymw1409Model.kymw1409Component = this;
    if (this.inputVO.pCodeList != null) {
      // InputVOをマネージにセット
      // 受注コード
      this.kymw1409Model.orderCode = this.inputVO.orderCode;
      // 生協コード
      this.kymw1409Model.coopCode = this.inputVO.coopCode;
      // Ｐコード
      this.kymw1409Model.pCodeList = this.inputVO.pCodeList.map(e => ({PCode: e}));
      if (this.kymw1409Model.pCodeList && this.kymw1409Model.pCodeList.length > 0) {
        this.kymw1409Model.pCode = this.kymw1409Model.pCodeList[0].PCode;
      }
      // マークイメージ
      this.kymw1409Model.imgMarkFileURL = null;
      // 注文商品区分
      this.kymw1409Model.orderGoodsFlg = this.inputVO.orderGoodsFlg;
    } else {
      // 受注コード
      this.kymw1409Model.orderCode = null;
      // 生協コード
      this.kymw1409Model.coopCode = null;
      // Ｐコード
      this.kymw1409Model.pCodeList = null;
      // マークイメージ
      this.kymw1409Model.imgMarkFileURL = null;
      // 注文商品区分
      this.kymw1409Model.orderGoodsFlg = null;
    }
    this.kymw1409Model.markGroup = '';

    if (this.inputVO.pCodeList.length > 0) {
      this.getMarkListService.execute(this.kymw1409Model, this.createMarkListVO());
    } else {
      this.kymw1409Model.cmbMarkGroupList = new Array<any>();
      this.kymw1409Model.markGroupList = new Array<any>();
      this.kymw1409Model.lblGuideGoodsName = '';
      this.kymw1409Model.lblGuideStandardName = '';
      this.kymw1409Model.pCodeList = new Array<any>();
      this.kymw1409Model.markInfoList = new Array<any>();
      this.kymw1409Model.markInfoListDisp = new Array<any>();
      this.kymw1409Model.selectedMarkList = new Array<any>();
      this.kymw1409Model.selectedMarkList = new Array<any>();
      this.updateDataGridViewColumn();
    }

    // 編集モード設定を行う
    if (this.inputVO.editMode === '1' ||
      this.getFuncPermission('KYMW1400') !== this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {
      this.kymw1409Model.enabledMode = '0';
      this.kymw1409Model.disabledGoodsFlagALL = true;
    } else {
      this.kymw1409Model.enabledMode = '1';
      this.kymw1409Model.disabledGoodsFlagALL = false;
    }

    // グリッド初期処理
    this.gridInit();
  }

  /**
   * グリッド初期処理
   *
   * @private
   * @memberof KYMW1409Component
   */
  private gridInit(): void {
    // マークグループリスト　選択行変更時
    this.dtg_MarkListDetail.selectionChanged.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      if (e.row > -1) {
        this.kymw1409Model.imgMarkFileURL = this.dtg_MarkListDetail.selectedItems[0].img_MarkFileName;
      }
    });

    // マークグループリスト　データ変更時
    this.dtg_MarkListDetail.itemsSourceChanged.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      this.dtg_MarkListDetail.select(-1, -1);

      this.kymw1409Model.imgMarkFileURL = null;
    });

    // 商品情報詳細リスト　データ変更時
    this.dtg_GoodsInfoDetail.itemsSourceChanged.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      this.dtg_GoodsInfoDetail.select(-1, -1);
    });
  }

  /**
   * インプットVo設定
   *
   * @memberof KYMW1409Component
   */
  public inputParameterSetting(): void {
    this.inputVO = this.iInputVOArray;
  }

  /**
   * インプットVo設定
   *
   * @param {KYMW1409InputModel} inputVO
   * @memberof KYMW1409Component
   */
  public setInputVO(inputVO: KYMW1409InputModel): void {
    this.inputVO = inputVO;
    // 初期処理を呼び出す
    this.init_load();
  }

  /*--------------------------------------------------------------------------------------------
  /* event area
  /*--------------------------------------------------------------------------------------------*/
  /**
   * 「マークグループ」コンボボックスを変更した時に呼び出されるメソッド。
   *
   * @memberof KYMW1409Component
   */
  public eventMarkGroupName_CHANGEHandler(): void {
    const code: string = this.kymw1409Model.markGroup;
    // マークグループの指定があるか
    if (code === '') {
      this.kymw1409Model.markInfoListDisp = this.kymw1409Model.markInfoList;
    } else {
      this.kymw1409Model.markInfoListDisp = this.kymw1409Model.markInfoList.filter((item) => this.doFilter(item));
    }
  }

  /**
   * 「Ｐコード」コンボボックスを変更した時に呼び出されるメソッド。
   *
   * @memberof KYMW1409Component
   */
  public eventPCode_CHANGEHandler(): void {
    this.changePCodeComboBox();
  }

  /**
   * 「マーク使用」チェックボックスを変更した時に呼び出されるメソッド。
   *
   * @param {*} data コールバック・イベントへの参照
   * @memberof KYMW1409Component
   */
  public eventUseMark_CHANGEHandler(data: any): void {
    // 保存領域のＰコード
    const workPCodeList: Array<any> = this.inputVO.pCodeList;
    // 選択状態
    const status: boolean = data.status;
    // 選択されたＰコード
    const pCode: string = data.pCode;
    // サーバへ送信するＰコード一覧
    const pCodeList: Array<any> = new Array<any>();
    // サーバへ送信するマークコード
    let markCode = String('');
    // Ｐコードの場所(何カラム目か)
    let pCodeIndex = Number(0);
    // 選択されている行のデータを取得する
    const selectedList: Array<any> = this.dtg_MarkListDetail.selectedItems;
    // 選択されている行からマークコードを取得する
    markCode = selectedList[0].MarkCode;
    // いつでも注文の商品情報（作業用）
    const workNvalInputList: Array<any> = this.inputVO.NvalInputList;
    // いつでも注文の商品情報
    const nvalInputList: Array<any> = new Array<any>();
    // 「すべての商品に同一の設定」がチェックされているか
    if (this.kymw1409Model.goodsFlagALL === true) {
      // 選択したマークの全商品をチェックする
      for (let j = Number(0); j < workPCodeList.length; j++) {
        // チェックボックスの変更が必要か
        if (selectedList[0][workPCodeList[j]] !== status || pCode === workPCodeList[j]) {
          // ステータスを変更
          this.dtg_MarkListDetail.selectedItems[0][workPCodeList[j]] = status;
          // 変更対象のＰコードをセット
          pCodeList.push(workPCodeList[j]);
          // いつでも注文
          if (workNvalInputList.length > 0) {
            nvalInputList.push(workNvalInputList[j]);
          }
        }
      }
      // 「Ｐコードコンボボックス値変更」イベントを発生し、「選択マーク一覧」を再表示
      this.changePCodeComboBox();
    } else {
      // Ｐコードのカラムを取得する
      for (let i = Number(0); i < workPCodeList.length; i++) {
        if (pCode === workPCodeList[i]) {
          pCodeIndex = i;
          break;
        }
      }
      // ステータスを変更
      this.dtg_MarkListDetail.selectedItems[0][workPCodeList[pCodeIndex]] = status;
      // 選択したＰコードをセット
      pCodeList.push(pCode);
      // いつでも注文
      if (workNvalInputList.length > 0) {
        nvalInputList.push(workNvalInputList[pCodeIndex]);
      }
      // 選択したＰコードと「Ｐコードコンボボックス」の表示値が一致するか
      if (this.kymw1409Model.pCode === pCode) {
        // 「Ｐコードコンボボックス値変更」イベントを発生し、「選択マーク一覧」を再表示
        this.changePCodeComboBox();
      }
    }

    // サーバへの更新処理
    if (status === true) {
      // 登録処理
      for (const targetPcode of pCodeList) {
        if (this.kymw1409Model.blockDuplicateMarkCode[targetPcode].includes(markCode)) {
          // 登録済みの再度登録防止
          return
        } else {
          this.kymw1409Model.blockDuplicateMarkCode[targetPcode].push(markCode)
        }
      }

      // 変更されたデータを取得する
      const registVO: RegistUseMarkModel = new RegistUseMarkModel();
      registVO.orderCode = this.kymw1409Model.orderCode;
      registVO.coopCode = this.kymw1409Model.coopCode;
      registVO.pCode = pCodeList;
      registVO.markCode = markCode;
      registVO.orderGoodsFlg = this.inputVO.orderGoodsFlg;
      registVO.orderGoodsFlgKoma = this.inputVO.orderGoodsFlgKoma;
      if (this.inputVO.NvalInputList.length === 0) {
        for (let j = Number(0); j < workPCodeList.length; j++) {
          const nvalInput: NvalInputModel = new NvalInputModel();
          nvalInput.itemCode = this.inputVO.itemCode;
          nvalInput.orderNum6Digits = this.inputVO.orderNum6Digits;
          nvalInput.receiptSOrderCode = this.inputVO.receiptSOrderCode;
          nvalInputList.push(nvalInput);
        }
        registVO.nvalList = nvalInputList;
      } else {
        registVO.nvalList = nvalInputList;
      }

      this.registUseMarkService.execute(this.kymw1409Model, registVO);
    } else {
      // 解除処理
      for (const targetPcode of pCodeList) {
        if (this.kymw1409Model.blockDuplicateMarkCode[targetPcode].includes(markCode)) {
          const index = this.kymw1409Model.blockDuplicateMarkCode[targetPcode].indexOf(markCode);
          this.kymw1409Model.blockDuplicateMarkCode[targetPcode].splice(index, 1);
        }
      }
      // 変更されたデータを取得する
      const deleteVO: DeleteUseMarkModel = new DeleteUseMarkModel();
      deleteVO.orderCode = this.kymw1409Model.orderCode;
      deleteVO.coopCode = this.kymw1409Model.coopCode;
      deleteVO.pCode = pCodeList;
      deleteVO.markCode = markCode;
      deleteVO.orderGoodsFlg = this.inputVO.orderGoodsFlg;
      deleteVO.orderGoodsFlgKoma = this.inputVO.orderGoodsFlgKoma;
      if (this.inputVO.NvalInputList.length === 0) {
        for (let j = Number(0); j < workPCodeList.length; j++) {
          const nvalInput: NvalInputModel = new NvalInputModel();
          nvalInput.itemCode = this.inputVO.itemCode;
          nvalInput.orderNum6Digits = this.inputVO.orderNum6Digits;
          nvalInput.receiptSOrderCode = this.inputVO.receiptSOrderCode;
          nvalInputList.push(nvalInput);
          deleteVO.nvalList = nvalInputList;
        }
      } else {
        deleteVO.nvalList = nvalInputList;
      }

      this.deleteUseMarkService.execute(this.kymw1409Model, deleteVO);
    }
  }

  /*--------------------------------------------------------------------------------------------
  /* util area
  /*--------------------------------------------------------------------------------------------*/
  /**
   * 選択されている商品の商品名取得
   *
   * @private
   * @returns {string}
   * @memberof KYMW1409Component
   */
  private getGuideGoodsname(): string {
    for (let index = Number(0); index < this.kymw1409Model.pCodeList.length; index++) {
      if (this.kymw1409Model.pCodeList[index].PCode === this.kymw1409Model.pCode) {
        return this.kymw1409Model.pCodeList[index].GuideGoodsName;
      }
    }
  }

  /**
   * 選択されている商品の規格名取得
   *
   * @private
   * @returns {string}
   * @memberof KYMW1409Component
   */
  private getGuideStandarName(): string {
    for (let index = Number(0); index < this.kymw1409Model.pCodeList.length; index++) {
      if (this.kymw1409Model.pCodeList[index].PCode === this.kymw1409Model.pCode) {
        return this.kymw1409Model.pCodeList[index].GuideStandardName;
      }
    }
  }

  /**
   *「Ｐコードコンボボックス値変更」
   * 選択マーク一覧作成
   *
   * @memberof KYMW1409Component
   */
  public changePCodeComboBox(): void {
    // Ｐコード取得
    const pCode: string = this.kymw1409Model.pCode;
    if (pCode != null && pCode.length !== 0) {
      // 商品名ラベルの設定
      this.kymw1409Model.lblGuideGoodsName = this.getGuideGoodsname();
      // 規格名ラベルの設定
      this.kymw1409Model.lblGuideStandardName = this.getGuideStandarName();
    }
    // 保存領域のＰコード
    const workPCodeList: Array<any> = this.inputVO.pCodeList;
    // マーク名の場所(Ｐコード数 + 3)
    const markCount: number = workPCodeList.length + 3;
    // Ｐコードの場所(何カラム目か)
    let pCodeIndex = Number(0);
    // データフィールドの行数
    const rowCount: number = this.kymw1409Model.markInfoListDisp.length;
    // データ
    const dataArray: Array<any> = this.kymw1409Model.markInfoListDisp;
    // マークグループリスト
    const groupList: Array<any> = this.kymw1409Model.markGroupList;
    // マークグループ数
    const groupCount: number = this.kymw1409Model.markGroupList.length;
    // マーク名
    let mark = String('');
    // 表示用マーク
    let markNames = String('');
    // 作業用配列
    const showArray: Array<any> = new Array<any>();

    // Ｐコードのカラムを取得する
    for (let i = Number(0); i < workPCodeList.length; i++) {
      if (pCode === workPCodeList[i]) {
        pCodeIndex = i;
        break;
      }
    }

    // マークグループでループ
    // ただし先頭行はブランク
    for (let j = Number(1); j < groupCount; j++) {
      markNames = '';
      // 全行数分ループする
      for (let k = Number(0); k < rowCount; k++) {
        // マークグループの一致と選択状態を確認
        if (groupList[j].code === dataArray[k].MarkGroupCode && dataArray[k][workPCodeList[pCodeIndex]] === true) {
          // マーク名取得
          mark = dataArray[k].MarkName;
          // マーク名セット
          if (markNames === '') {
            markNames = mark;
          } else {
            markNames = markNames + ' , ' + mark;
          }
        }
      }

      showArray.push({ MarkGroupName: this.kymw1409Model.markGroupList[j].lbl, MarkNames: markNames });

    }

    this.kymw1409Model.selectedMarkList = showArray;
    this.cmb_MarkGroup.nativeElement.focus();

  }

  /**
   * ページ一覧のフィルタリング
   *
   * @param {*} item 行エンティティ
   * @returns {boolean}
   * @memberof KYMW1409Component
   */
  public doFilter(item: any): boolean {
    let flag = Boolean(false);
    if (item['MarkGroupCode'] === this.kymw1409Model.markGroup) {
      flag = true;
    }
    return flag;
  }

  /**
   * 一覧DataGridViewのカラム再構成
   *
   * @memberof KYMW1409Component
   */
  public updateDataGridViewColumn(): void {
    this.editColumns = new Array<any>();
    const pCodeList: Array<any> = this.inputVO.pCodeList;
    for (let j = Number(0); j < pCodeList.length; j++) {
      this.editColumns.push(pCodeList[j]);
    }
    // Pコードがない場合
    if (this.editColumns.length === 0) {
      this.editColumns.push('');
    }
    // グリッドの列幅調整
    if (this.editColumns.length > 3) {
      this.colWidth = this.COLUMN_WIDTH_MINIMUN;
    } else {
      this.colWidth = this.COLUMN_WIDTH_DEFAULT / this.editColumns.length;
    }
  }

  /**
   * マーク一覧取得VO設定
   *
   * @private
   * @returns {MarkListModel}
   * @memberof KYMW1409Component
   */
  private createMarkListVO(): MarkListModel {
    const vo: MarkListModel = new MarkListModel();

    // 受注コード
    vo.orderCode = this.inputVO.orderCode;
    // 生協コード
    vo.coopCode = this.inputVO.coopCode;
    // Pコード
    vo.pCodeList = this.inputVO.pCodeList;
    // マークグループコード
    vo.markGroupCode = '';
    // 重複
    vo.duplication = '';
    // マークコード
    vo.markCode = '';
    // マーク名
    vo.markName = '';
    // マークファイル名
    vo.img_MarkFileName = '';
    // 受付開始受注コード
    vo.receiptSOrderCode = '';
    // 注文コード
    vo.orderNum6Digits = '';
    // アイテムコード
    vo.itemCode = '';
    // 注文商品区分
    vo.orderGoodsFlg = this.inputVO.orderGoodsFlg;
    // 注文商品区分（コマ割画面遷移用）
    vo.orderGoodsFlgKoma = this.inputVO.orderGoodsFlgKoma;
    // いつでも注文
    vo.nvalList = new Array<any>();
    if (this.inputVO.NvalInputList != null && this.inputVO.NvalInputList.length !== 0) {
      // いつでも注文商品・いつ注W掲載商品の場合、コマ割り画面から取得したリストをvoに設定
      vo.nvalList = this.inputVO.NvalInputList;
    } else {
      // 通常注文商品の場合、Ｐコードリスト数分空を設定
      for (let i = Number(0); i < this.inputVO.pCodeList.length; i++) {
        const nvalInput: NvalInputModel = new NvalInputModel();
        vo.nvalList.push(nvalInput);
      }
    }
    return vo;
  }
}
